module.exports = __webpack_public_path__ + "img/3.5324f43a.png";